export default __webpack_public_path__ + "static/media/mock_empty.87725390.svg";